<template>
    <v-menu v-model="menu" :close-on-content-click="false" :nudge-width="200" offset-y>
        <template v-slot:activator="{ on, attrs }">
            <v-btn color="primary" v-bind="attrs" v-on="on"> 데이터 요청하기 </v-btn>
        </template>
        <v-card>
            <v-row no-gutters>
                <v-col cols="8" class="pa-3">
                    <v-password-field v-model="subPassword" v-bind="attrs_input" label="비밀번호 입력" autocomplete="new-password" @keydown.enter="verify"></v-password-field>
                </v-col>
                <v-col cols="4" class="pt-3 pl-5">
                    <v-btn color="primary" @click="verify">요청</v-btn>
                </v-col>
            </v-row>
        </v-card>
    </v-menu>
</template>

<script>
import api from "@/api";
import cryptoAes from "@/plugins/crypto-aes";
import { attrs_input } from "@/assets/variables/attrs";
import vPasswordField from "@/components/plugins/vuetify/v-password-field.vue";

export default {
    components: {
        vPasswordField,
    },
    data: () => ({
        attrs_input,
        menu: false,

        subPassword: "",
    }),
    methods: {
        async verify() {
            try {
                let subPassword = cryptoAes.encrypt(this.subPassword);

                let { isVerified } = await api.console.me.verify({ subPassword });

                if(isVerified) this.$emit('verify');
            } catch (error) {
                console.error(error);
                // alert(error.response ? error.response.data.message : error.message);
            }
        },
    },
};
</script>

<style>
</style>